import { axiosApi } from "../../../../../../../api/dbAxios";

export const createTeamComments = async (
  regulatorCode: string | undefined,
  case_no: string | undefined,
  text: string | undefined,
) => {
  const test_email = "ykozak@deloittece.com";
  try {
    const isLocalhost =
      typeof window !== "undefined" && window.location.hostname === "localhost";
    const response = await axiosApi.post(
      `/items/${regulatorCode}/${case_no}/comments/`,
      { text },
      {
        params: isLocalhost ? { test_email } : {},
      },
    );

    return response.data;
  } catch (error: any) {
    console.error("Error creating Team Comments:", error);
    throw error.response.data[0];
  }
};
